"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _AdresseBase = _interopRequireDefault(require("./AdresseBase"));
var _DateiBase = _interopRequireDefault(require("./DateiBase"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * KFV LDS API
 * Die KFV LDS API bietet eine Schnittstelle zum Backend der PWA.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The Fortbildung model module.
 * @module model/Fortbildung
 * @version 0.0.1
 */
class Fortbildung {
  /**
   * Constructs a new <code>Fortbildung</code>.
   * @alias module:model/Fortbildung
   * @param typ {String} 
   * @param titel {String} 
   * @param beschreibung {String} 
   * @param kapazitaet {Number} 
   * @param datum {Date} 
   * @param ende {Date} 
   * @param id {Number} 
   * @param currentKapazitaet {Number} 
   * @param booked {Boolean} 
   */
  constructor(typ, titel, beschreibung, kapazitaet, datum, ende, id, currentKapazitaet, booked) {
    Fortbildung.initialize(this, typ, titel, beschreibung, kapazitaet, datum, ende, id, currentKapazitaet, booked);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj, typ, titel, beschreibung, kapazitaet, datum, ende, id, currentKapazitaet, booked) {
    obj['typ'] = typ;
    obj['titel'] = titel;
    obj['beschreibung'] = beschreibung;
    obj['kapazitaet'] = kapazitaet;
    obj['datum'] = datum;
    obj['ende'] = ende;
    obj['id'] = id;
    obj['current_kapazitaet'] = currentKapazitaet;
    obj['booked'] = booked;
  }

  /**
   * Constructs a <code>Fortbildung</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/Fortbildung} obj Optional instance to populate.
   * @return {module:model/Fortbildung} The populated <code>Fortbildung</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new Fortbildung();
      if (data.hasOwnProperty('typ')) {
        obj['typ'] = _ApiClient.default.convertToType(data['typ'], 'String');
      }
      if (data.hasOwnProperty('titel')) {
        obj['titel'] = _ApiClient.default.convertToType(data['titel'], 'String');
      }
      if (data.hasOwnProperty('beschreibung')) {
        obj['beschreibung'] = _ApiClient.default.convertToType(data['beschreibung'], 'String');
      }
      if (data.hasOwnProperty('kapazitaet')) {
        obj['kapazitaet'] = _ApiClient.default.convertToType(data['kapazitaet'], 'Number');
      }
      if (data.hasOwnProperty('notify_leiter')) {
        obj['notify_leiter'] = _ApiClient.default.convertToType(data['notify_leiter'], 'Boolean');
      }
      if (data.hasOwnProperty('notify_ortswehrfuehrer')) {
        obj['notify_ortswehrfuehrer'] = _ApiClient.default.convertToType(data['notify_ortswehrfuehrer'], 'Boolean');
      }
      if (data.hasOwnProperty('datum')) {
        obj['datum'] = _ApiClient.default.convertToType(data['datum'], 'Date');
      }
      if (data.hasOwnProperty('ende')) {
        obj['ende'] = _ApiClient.default.convertToType(data['ende'], 'Date');
      }
      if (data.hasOwnProperty('adresse')) {
        obj['adresse'] = _AdresseBase.default.constructFromObject(data['adresse']);
      }
      if (data.hasOwnProperty('bild')) {
        obj['bild'] = _DateiBase.default.constructFromObject(data['bild']);
      }
      if (data.hasOwnProperty('datei')) {
        obj['datei'] = _DateiBase.default.constructFromObject(data['datei']);
      }
      if (data.hasOwnProperty('meetingLink')) {
        obj['meetingLink'] = _ApiClient.default.convertToType(data['meetingLink'], 'String');
      }
      if (data.hasOwnProperty('id')) {
        obj['id'] = _ApiClient.default.convertToType(data['id'], 'Number');
      }
      if (data.hasOwnProperty('current_kapazitaet')) {
        obj['current_kapazitaet'] = _ApiClient.default.convertToType(data['current_kapazitaet'], 'Number');
      }
      if (data.hasOwnProperty('booked')) {
        obj['booked'] = _ApiClient.default.convertToType(data['booked'], 'Boolean');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>Fortbildung</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>Fortbildung</code>.
   */
  static validateJSON(data) {
    // check to make sure all required properties are present in the JSON string
    for (const property of Fortbildung.RequiredProperties) {
      if (!data[property]) {
        throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
      }
    }
    // ensure the json data is a string
    if (data['typ'] && !(typeof data['typ'] === 'string' || data['typ'] instanceof String)) {
      throw new Error("Expected the field `typ` to be a primitive type in the JSON string but got " + data['typ']);
    }
    // ensure the json data is a string
    if (data['titel'] && !(typeof data['titel'] === 'string' || data['titel'] instanceof String)) {
      throw new Error("Expected the field `titel` to be a primitive type in the JSON string but got " + data['titel']);
    }
    // ensure the json data is a string
    if (data['beschreibung'] && !(typeof data['beschreibung'] === 'string' || data['beschreibung'] instanceof String)) {
      throw new Error("Expected the field `beschreibung` to be a primitive type in the JSON string but got " + data['beschreibung']);
    }
    // validate the optional field `adresse`
    if (data['adresse']) {
      // data not null
      _AdresseBase.default.validateJSON(data['adresse']);
    }
    // validate the optional field `bild`
    if (data['bild']) {
      // data not null
      _DateiBase.default.validateJSON(data['bild']);
    }
    // validate the optional field `datei`
    if (data['datei']) {
      // data not null
      _DateiBase.default.validateJSON(data['datei']);
    }
    // ensure the json data is a string
    if (data['meetingLink'] && !(typeof data['meetingLink'] === 'string' || data['meetingLink'] instanceof String)) {
      throw new Error("Expected the field `meetingLink` to be a primitive type in the JSON string but got " + data['meetingLink']);
    }
    return true;
  }
}
Fortbildung.RequiredProperties = ["typ", "titel", "beschreibung", "kapazitaet", "datum", "ende", "id", "current_kapazitaet", "booked"];

/**
 * @member {String} typ
 */
Fortbildung.prototype['typ'] = undefined;

/**
 * @member {String} titel
 */
Fortbildung.prototype['titel'] = undefined;

/**
 * @member {String} beschreibung
 */
Fortbildung.prototype['beschreibung'] = undefined;

/**
 * @member {Number} kapazitaet
 */
Fortbildung.prototype['kapazitaet'] = undefined;

/**
 * @member {Boolean} notify_leiter
 * @default false
 */
Fortbildung.prototype['notify_leiter'] = false;

/**
 * @member {Boolean} notify_ortswehrfuehrer
 * @default false
 */
Fortbildung.prototype['notify_ortswehrfuehrer'] = false;

/**
 * @member {Date} datum
 */
Fortbildung.prototype['datum'] = undefined;

/**
 * @member {Date} ende
 */
Fortbildung.prototype['ende'] = undefined;

/**
 * @member {module:model/AdresseBase} adresse
 */
Fortbildung.prototype['adresse'] = undefined;

/**
 * @member {module:model/DateiBase} bild
 */
Fortbildung.prototype['bild'] = undefined;

/**
 * @member {module:model/DateiBase} datei
 */
Fortbildung.prototype['datei'] = undefined;

/**
 * @member {String} meetingLink
 */
Fortbildung.prototype['meetingLink'] = undefined;

/**
 * @member {Number} id
 */
Fortbildung.prototype['id'] = undefined;

/**
 * @member {Number} current_kapazitaet
 */
Fortbildung.prototype['current_kapazitaet'] = undefined;

/**
 * @member {Boolean} booked
 */
Fortbildung.prototype['booked'] = undefined;
var _default = exports.default = Fortbildung;